import React, { useContext } from 'react'
import { useQuery } from '@apollo/react-hooks'
import get from 'lodash/get'
import { Col } from 'antd'

import { AppContext } from 'AppContext'
import { generateDashboardSummary } from 'utils/misc'
import {
  GET_DASHBOARD_SUMMARY,
  GET_REVENUE_INCOME_SUMMARY,
} from '../graphql/Queries'
import IconWithTextCardNew from './IconWithTextCardNew'
import TotalFund from 'assets/images/new-images/revenue-red.svg'
import TotalUser from 'assets/images/new-images/user-tree-red.svg'
import { numDifferentiation } from 'utils/misc'

export default function () {
  let dashboardData = []
  let dashboardSpliceData = []
  const {
    state: {
      selectedGroup,
      selectedStrategy,
      selectedAssociate,
      currentUser,
    } = {},
  } = useContext(AppContext) || {}

  const id = currentUser?.id
  const isAudit = currentUser?.role === 'AUDIT'

  const { data, loading } = useQuery(GET_DASHBOARD_SUMMARY, {
    variables: {
      where: {
        groupId: selectedGroup,
        strategyCode: selectedStrategy,
        associateId: selectedAssociate,
      },
    },
    fetchPolicy: 'cache-first',
  })

  const { data: revenueData } = useQuery(GET_REVENUE_INCOME_SUMMARY, {
    variables: { where: { userId: id ? [String(id)] : undefined } },
    skip: !id || isAudit,
    fetchPolicy: 'cache-first',
  })

  if (isAudit) {
    const summary = get(data, 'dashboardSummary[0]') || {}
    const clientCount = summary.Clients ?? 0
    const fundAmount = summary.TotalFund ? numDifferentiation(summary.TotalFund) : '₹0'
    const groupsCount = summary.totalGroups ?? 0
    const auditCards = [
      {
        cardColor: 'orange',
        icon: TotalUser,
        title: clientCount,
        subTitle: 'Mapped Clients',
      },
      {
        cardColor: 'cyan',
        icon: TotalFund,
        title: fundAmount,
        subTitle: 'Total Fund Under Audit',
      },
      {
        cardColor: 'purple',
        icon: TotalUser,
        title: groupsCount,
        subTitle: 'Audit Groups',
      },
    ]
    return (
      <>
        {auditCards.map((d, key) => (
          <Col key={key} xl={4} lg={6} md={6} sm={6} xs={24}>
            <IconWithTextCardNew {...d} />
          </Col>
        ))}
      </>
    )
  }
  if (get(revenueData, 'getTotalRevenueIncome')) {
    dashboardData = [
      ...dashboardData,
      {
        cardColor: 'light-blue',
        icon: TotalFund,
        title: get(revenueData, 'getTotalRevenueIncome').toFixed(2) || '-',
        subTitle: 'Revenue Income',
      },
    ]
  }

  if (loading || !get(data, 'dashboardSummary[0]')) return <></>

  if (get(data, 'dashboardSummary[0]')) {
    dashboardData = [
      ...dashboardData,
      ...generateDashboardSummary(get(data, 'dashboardSummary[0]')),
    ]
    dashboardSpliceData = [...dashboardData.splice(3, 5)]
  }

  return get(dashboardData, 'length') ? (
    <>
      {dashboardData.map((data, key) => {
        return (
          <Col key={key} xl={4} lg={6} md={6} sm={6} xs={24}>
            <IconWithTextCardNew {...data} />
          </Col>
        )
      })}
      {dashboardSpliceData.map((data, key) => {
        return (
          <Col key={key} xl={4} lg={6} md={6} sm={6} xs={24}>
            <IconWithTextCardNew {...data} />
          </Col>
        )
      })}
    </>
  ) : (
    <></>
  )
}
